<template>
  <el-form ref="ff" v-loading="loading" :model="formdata" label-width="100px">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="任务类型" prop="State" required>
          <el-radio-group v-model="formdata.State">
            <el-radio :label="9">即时工作</el-radio>
            <el-radio :label="0">任务计划</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="工作方式" prop="Type" required>
          <metaPicker
            type="schedule-type"
            :value.sync="formdata.Type"
            clearable
          />
        </el-form-item>
      </el-col>
      <template v-if="formdata.State == 0">
        <el-col :span="12">
          <el-form-item label="人员安排" prop="Operator">
            <staffPicker
              :value="formdata.UserName"
              @selectHandler="pickStaff"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="任务时间" prop="PlanTime" required>
            <el-date-picker
              type="datetime"
              v-model="formdata.PlanTime"
              value-format="yyyy-MM-dd HH:mm"
              :picker-options="{
                disabledDate: (time) => {
                  return time < new Date();
                },
              }"
              placeholder="请选择"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </template>
      <template v-else>
        <el-col :span="12">
          <el-form-item label="客户进度" prop="Step_Client" required>
            <metaPicker
              type="demand-step-client"
              :value.sync="formdata.Step_Client"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="公司进度" prop="Step_Corp" required>
            <metaPicker
              type="demand-step-corp"
              :value.sync="formdata.Step_Corp"
              clearable
            />
          </el-form-item>
        </el-col>
      </template>
    </el-row>
    <el-form-item label="客户单位" prop="Client">
      <el-input v-model="formdata.Client" disabled />
    </el-form-item>
    <el-form-item label="联系地址" prop="Address">
      <el-input v-model="formdata.Address" clearable />
    </el-form-item>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="联系人" prop="Linkman">
          <el-input v-model="formdata.Linkman" clearable />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="联系电话" prop="Linktel">
          <el-input v-model="formdata.Linktel" clearable />
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="工作内容" prop="Request">
      <el-input v-model="formdata.Request" clearable />
    </el-form-item>
    <el-form-item label="处理结果" prop="Result" v-if="formdata.State == 9">
      <el-input v-model="formdata.Result" clearable />
    </el-form-item>
    <el-form-item label="文件上传">
      <uploader
        ref="uploader"
        :data="{ Mode: 'schedule', ObjectId: formdata.Id }"
        multiple
        :auto-upload="false"
        accept=".jpg,.png,.xls,.xlsx,.pdf,.doc,.docx,.rar,.zip"
      >
        <el-link
          slot="trigger"
          icon="el-icon-upload"
          size="small"
          type="primary"
        >
          选取文件
        </el-link>
      </uploader>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="onSubmit(true)">保存</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  components: {
    metaPicker: () => import("@/views/system/meta/item/_picker.vue"),
    staffPicker: () => import("@/views/company/branch/staff/_input.vue"),
    uploader: () => import("@/views/system/file/multipleUpload"),
  },
  props: {
    source: { type: Object },
    layerid: { type: String },
  },
  data() {
    return {
      loading: false,
      formdata: {
        State: 9,
        ...this.source,
      },
    };
  },
  methods: {
    //选择人员
    pickStaff(res) {
      this.formdata.Operator = res.Id;
      this.formdata.UserName = res.Name;
    },
    //保存
    onSubmit() {
      this.$refs["ff"].validate((valid) => {
        if (valid && !this.loading) {
          this.loading = true;
          this.$apis.job.demand
            .progress(this.formdata)
            .then((scheduleId) => {
              return this.$refs.uploader.onSubmit(scheduleId);
            })
            .then(() => {
              this.$layer.close(this.layerid);
              this.$parent.loadData();
            })
            .catch((e) => {
              this.$message.error(e || "执行错误");
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>
